package ru.it_mozaika.sender.js.application.frames.triggers

import io.ktor.client.call.*
import js.core.ReadonlyRecord
import js.core.jso
import mui.material.*
import mui.material.styles.Theme
import mui.material.styles.useTheme
import mui.system.responsive
import mui.system.sx
import react.*
import react.router.useNavigate
import ru.it_mozaika.components.*
import ru.it_mozaika.sender.common.models.*
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.components.commonTableSkeletonFrame
import ru.it_mozaika.utils.checkResponseError
import ru.it_mozaika.sender.js.application.components.triggers.triggerDialog
import ru.it_mozaika.sender.js.application.components.triggers.triggersActionsDialog
import ru.it_mozaika.sender.js.application.frames.MainCard
import tanstack.react.table.useReactTable
import tanstack.table.core.*
import web.cssom.*

val triggersListFrame = VFC {
    val showNotification = useSnackbar().enqueueSnackbar
    val (triggers, setTriggers) = useState(listOf<TriggerTitle>())
    val (showDialog, setShowDialog) = useState(false)
    val (showDeleteDialog, setShowDeleteDialog) = useState(false)
    val (showStartDialog, setShowStartDialog) = useState(false)
    val (showStopDialog, setShowStopDialog) = useState(false)
    val (showFilter, setShowFilter) = useState(false)
    var (columnVisibility, setColumnVisibility) = useState<ReadonlyRecord<String, Boolean>>(jso {})
    val (columnOrder, setColumnOrder) = useState<ColumnOrderState>(jso {})
    val (selectedProperty, setSelectedProperty) = useState("")
    val (checkedProperties, setCheckedProperties) = useState(listOf<String>())
    val (propertiesFilter, setPropertiesFilter) = useState<List<ColumnsFilter>>(listOf())
    val (selectedTriggers, setSelectedTriggers) = useState<List<TriggerTitle>>(listOf())
    val (selectedTrigger, setSelectedTrigger) = useState<TriggerTitle>()
    val tableColumns = listOf("ID", "Наименование", "Категория", "Статус")
    var categories by useState(listOf<TriggerCategory>())
    val navigate = useNavigate()


    fun getTriggers() {
        Http.get("/triggers") { response ->
            response.checkResponseError()?.let {
                showNotification(it, jso { variant = AlertColor.error })
                return@get
            }
            setTriggers(response.body<List<TriggerTitle>>())
        }
        Http.get("/triggers/categories") { response ->
            response.checkResponseError()?.let {
                showNotification(it, jso { variant = AlertColor.error })
                return@get
            }
            categories =  response.body<List<TriggerCategory>>()
        }
    }
    useEffectOnce {
        getTriggers()
    }

    val table = useReactTable<TriggerTitle>(
        options = jso {
            columns = useMemo(tableColumns) {
                tableColumns.map { column ->
                    jso<ColumnDef<TriggerTitle, Any?>> {
                        accessorFn = { trigger, _ ->
                            when (column) {
                                "ID" -> trigger.id
                                "Наименование" -> trigger.name
                                "Категория" ->categories.find{it.id == trigger.category}?.name ?: "---"
                                "Статус" -> trigger.status.ruTitle
                                else -> ""
                            }
                        }
                        cell = ColumnDefTemplate { context ->
                            val value = context.getValue().toString()
                            Box.create {
                                +value
                            }
                        }
                        id = column
                        header = StringOrTemplateHeader(column)
                    }
                }
            }.toTypedArray()
            this.data = useMemo(triggers) { triggers.toTypedArray() }
            this.state = jso {
                this.columnVisibility = columnVisibility
                this.columnOrder = columnOrder
            }
            this.onColumnVisibilityChange = {
                columnVisibility = it.unsafeCast<ReadonlyRecord<String, Boolean>>()
                setColumnVisibility(it.unsafeCast<ReadonlyRecord<String, Boolean>>())
            }
            this.onColumnOrderChange = {
                setColumnOrder(it.unsafeCast<Array<String>>())
            }
            this.getCoreRowModel = getCoreRowModel()
            this.debugTable = true
            this.debugHeaders = true
            this.debugColumns = true
        }
    )
    triggerDialog {
        isOpen = showDialog
        this.onClose = {
            setShowDialog(false)
            setSelectedTrigger(null)
            getTriggers()
        }
        this.selected = selectedTrigger
    }
    triggersActionsDialog {
        this.delete = showDeleteDialog
        this.start = showStartDialog
        this.stop = showStopDialog
        this.selected = selectedTriggers
        this.onClose = {
            setShowDeleteDialog(false)
            setShowStopDialog(false)
            setShowStartDialog(false)
            getTriggers()
        }
    }
    MainCard {
        title = "Триггеры"
        actions = Stack.create {
            this.direction = responsive(StackDirection.row)
            this.divider = Divider.create {
                orientation = Orientation.vertical
            }
            asDynamic().spacing = 2
            sx {
                this.width = 100.pct
                border = 2.px
                this.alignItems = AlignItems.center
                this.justifyContent = JustifyContent.flexStart
            }
            AvatarButton {
                onClick = {
                    setSelectedTrigger(null)
                    setShowDialog(true)
                }
                tooltipTitle = "Создать"
                mui.icons.material.AddCircleOutlineSharp()
            }
        }
        commonTableSkeletonFrame {
            this.currentSelected = selectedTriggers.map { it.id }
            toolbarActions = Stack.create {
                this.direction = responsive(StackDirection.row)
                this.divider = Divider.create {
                    orientation = Orientation.vertical
                }
                asDynamic().spacing = 2
                sx {
                    this.width = 100.pct
                    border = 2.px
                    this.alignItems = AlignItems.center
                    this.justifyContent = JustifyContent.flexStart
                }
                if (checkedProperties.isNotEmpty()) {
                    filterOffButton {
                        this.propertiesFilter = checkedProperties
                        this.handleOnFilterOffClick = {
                            setCheckedProperties(listOf())
                            setPropertiesFilter(listOf())
                        }
                    }
                }
                if (selectedTriggers.size == 1) {

                    AvatarButton {
                        tooltipTitle = "Редактировать"
                        onClick = {
                            setSelectedTrigger(selectedTriggers.first())
                            setShowDialog(true)
                        }
                        mui.icons.material.CreateSharp()
                    }
                }
                if (selectedTriggers.map { it.status }.contains(TriggerStatus.Template)) {
                    AvatarButton {
                        onClick = {
                            setShowStartDialog(true)
                        }
                        tooltipTitle = "Запустить"
                        mui.icons.material.PlayCircleFilledWhite()
                    }
                }
                if (selectedTriggers.map { it.status }.contains(TriggerStatus.Started)) {
                    AvatarButton {
                        onClick = {
                            setShowStopDialog(true)
                        }
                        tooltipTitle = "Остановить"
                        palettecolor = useTheme<Theme>().palette.error
                        mui.icons.material.StopCircleSharp()
                    }
                }
                if (selectedTriggers.isNotEmpty()) {
                    AvatarButton {
                        disabled = selectedTriggers.map { it.status }.contains(TriggerStatus.Started)
                        onClick = {
                            setShowDeleteDialog(true)
                        }
                        tooltipTitle = "Удалить"
                        palettecolor = useTheme<Theme>().palette.error
                        mui.icons.material.DeleteForeverSharp()
                    }
                }
            }
            this.label = "triggers-list"
            this.propertiesFilter = propertiesFilter
            this.columnId = "ID"
            this.table = table
            this.onDoubleClickHandler = { id ->
                navigate("/editor/trigger/${id}")
            }
            this.onPropertySelect = { property ->
                setSelectedProperty(property)
                if (showFilter) setShowFilter(false) else setShowFilter(true)
            }
            this.onSelectionChanged = { newSelected ->
                val newList = newSelected.mapNotNull { id ->
                    triggers.associateBy { it.id }[id]
                }
                setSelectedTriggers(newList)
            }
        }
    }
}